import React from "react";
import { channelCategories } from "_constants";
import { Field } from "formik";
import ExpandButton from "forms/components/ExpandButton";
import FormContainer from "forms/components/FormContainer";
import FormRow from "forms/components/FormRow";
import { DropdownField, RenderTypeahead } from "forms/fields";
import PropTypes from "prop-types";

import { Translate } from "utils";
import { isEmail } from "utils/validation";

const { t } = new Translate("DealForm");

const Channel = (props) => {
  const {
    currentUserCompanyID,
    formik: {
      setFieldValue,
      values: { _channelExpanded: isExpanded },
    },
  } = props;

  if (!isExpanded) {
    return (
      <ExpandButton
        label={t("channel.expand")}
        onExpand={() => setFieldValue("_channelExpanded", true)}
      />
    );
  }

  const searchParameters = {
    facets: "related_company_ids",
    filters: `related_company_ids:${currentUserCompanyID}`,
  };

  return (
    <FormContainer title={t("channel.title")}>
      <FormRow>
        <Field
          component={RenderTypeahead}
          label={t("company")}
          name="channel.company"
          onSelect={({ category, company }) => setFieldValue("channel", { company, category })}
          searchIndex="Channel_by_company"
          searchKey="company"
          searchParameters={searchParameters}
          autoFocus
        />
        <Field
          component={DropdownField}
          label={t("category")}
          name="channel.category"
          valueExtractor={(v) => v && t(`channelCategories.${v}`)}
          values={channelCategories}
        />
      </FormRow>
      <FormRow>
        <Field
          component={RenderTypeahead}
          label={t("fullName")}
          name="channel.name"
          onSelect={(contact) => setFieldValue("channel", contact)}
          searchIndex="Channel_by_name"
          searchKey="name"
          searchParameters={searchParameters}
        />
        <Field
          component={RenderTypeahead}
          label={t("email")}
          name="channel.email"
          onSelect={(contact) => setFieldValue("channel", contact)}
          searchIndex="Channel_by_email"
          searchKey="email"
          searchParameters={searchParameters}
          type="email"
          validate={isEmail}
        />
      </FormRow>
    </FormContainer>
  );
};

Channel.propTypes = {
  currentUserCompanyID: PropTypes.number.isRequired,
  formik: PropTypes.shape({
    values: PropTypes.shape({
      _channelExpanded: PropTypes.bool,
    }),
    setFieldValue: PropTypes.func,
  }),
};

export default Channel;
